import React from 'react';
import { Dialog } from '@mui/material';
import Slider from 'react-slick';
import './ImageModal.css';

const ImageModal = ({ images, initialImage, onClose }) => {
  const initialSlideIndex = images.findIndex(img => img === initialImage);

  const sliderSettings = {
    initialSlide: initialSlideIndex,
    dots: true, // Hide the dots
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  
    appendDots: dots => (
      <div style={{ padding: '10px' }}>
        <ul style={{ margin: '0px', padding: '0px' }}> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <div
        className="custom-dot"
        style={{
          width: '10px',
          height: '10px',
          background: 'lightcoral',
          position:'absolute',
          top:'-5px',
          zIndex:'100',
          borderRadius: '50%',
          display: 'inline-block',
          margin: '-10px 5px 0 5px'
        }}
      />
    ),
  };

  return (
    <Dialog
      open={Boolean(images.length)}
      onClose={onClose}
      fullWidth
      maxWidth="md" // Set max width to medium for better image display
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: 'transparent',
          color: '#fff',
          overflow: 'hidden',
          padding: 0,
          border: 'none',
          outline:'none'
        }
        
      }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.85)', // Darken the background more
        }
      }}
    >
      <div className="modal-container">
        <Slider {...sliderSettings}>
          {images.map((img, index) => (
            <div key={index} style={{ textAlign: 'center' }}>
              <img
                src={img}
                alt={`Slide ${index + 1}`}
                style={{
                  maxWidth: '100%', // Increase image width
                  maxHeight: '80vh',
                  borderRadius: '10px',
                  margin: '0 auto', // Center the image horizontally
                }}
              />
            </div>
          ))}
        </Slider>
      </div>
    </Dialog>
  );
};

export default ImageModal;
